import React from 'react';
import { useIdentity } from '../../hooks';
import { useLocation } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
export var GuestGuard = function GuestGuard(_ref) {
  var children = _ref.children,
      _ref$defaultRedirectU = _ref.defaultRedirectUrl,
      defaultRedirectUrl = _ref$defaultRedirectU === void 0 ? '/' : _ref$defaultRedirectU;
  var user = useIdentity();
  var location = useLocation();
  var state = location.state;

  if (user) {
    if (state === null || state === void 0 ? void 0 : state.redirect) {
      return React.createElement(Navigate, {
        to: state.redirect
      });
    } else {
      return React.createElement(Navigate, {
        to: defaultRedirectUrl
      });
    }
  } else {
    return React.createElement(React.Fragment, null, children);
  }
};